import { createAction, props } from '@ngrx/store';
import { Position} from '../../../units/models/position';

export const getPositions = createAction(
  '[Positions] Get Positions',
  props<{unitIds: number[]}>()
);

export const updatePositions = createAction(
  '[Positions] Update Positions',
  props<{positions: Position[]}>()
);

export type PositionsActionsUnion = ReturnType<
  typeof getPositions |
  typeof updatePositions
  >;
